import {Pipe, PipeTransform} from "@angular/core";
import * as moment from "moment";
import {IPersonAge} from "../interfaces/person.age";
import {LABEL_SUFFIX, TranslateService} from "../../../common/translate";

@Pipe({name: 'cpAge'})
export class AgePipe implements PipeTransform {
	constructor(private tra:TranslateService) {
	}
	transform(value:Date|string|IPersonAge) : string {
		if (!value) {
			return '';
		}

		let date = value;
		let now : Date|string = new Date();

		if (value.hasOwnProperty('birthDate')) {
			let personAge = <IPersonAge>value;
			date = personAge.birthDate;

			if (personAge.isDeceased  || personAge.deceased) {
				now = personAge.deathDate;
			}
		}

		let result = '';

		let daysBetween= +Math.floor(moment(now).diff(moment(<Date|string>date), 'days', true));
		if (daysBetween<14) {
			result = daysBetween +' '+ <string>this.tra.instant('Day' + LABEL_SUFFIX);
		}else if (daysBetween<62) {
			let weeksBetween= +Math.floor(daysBetween/7);
			result = weeksBetween+' '+ <string>this.tra.instant('Week' + LABEL_SUFFIX);
		}else {
			let monthsBetween = moment(now).diff(moment(<Date | string>date), 'months', true);
			if (monthsBetween<=24){
				result = +Math.floor(monthsBetween)+ ' '+<string>this.tra.instant('Month' + LABEL_SUFFIX);
			}else {
				let years = +Math.floor(monthsBetween / 12);
				let monthsInYear = +Math.floor(monthsBetween % 12);

				if (years > 0) {
					result += years + <string>this.tra.instant('Year' + LABEL_SUFFIX);
				}

				if (monthsInYear > 0) {
					if (result !== '') {
						result += ' ';
					}
					result += monthsInYear + <string>this.tra.instant('Month' + LABEL_SUFFIX);
				}
			}
		}

		return result.trim();
	}
}
